import TBackTop from './back2top.vue'
export default TBackTop



// WEBPACK FOOTER //
// ./src/components/back2top/index.js